"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3610],{

/***/ 31233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Image; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/components/Image/Picture.js


var defaultProps = {};
var propTypes = {
    children: (prop_types_default()).node.isRequired
};
function Picture(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        children: children
    });
};
Picture.defaultProps = defaultProps;
Picture.propTypes = propTypes;

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/components/Image/Img.js



/* eslint-disable @next/next/no-img-element */ 


var Img_defaultProps = {
    fluid: true,
    title: null,
    className: null
};
var Img_propTypes = {
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string.isRequired,
    fluid: (prop_types_default()).bool,
    title: (prop_types_default()).string,
    className: (prop_types_default()).string
};
function Img(_param) {
    var src = _param.src, alt = _param.alt, fluid = _param.fluid, title = _param.title, className = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "alt",
        "fluid",
        "title",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({
        src: src,
        alt: alt,
        title: title,
        className: (0,clsx_m/* default */.Z)(fluid && "h-auto max-w-full", className),
        loading: "lazy"
    }, rest));
}
Img.defaultProps = Img_defaultProps;
Img.propTypes = Img_propTypes;
var ImgForwardRef = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, (0,_object_spread/* default */.Z)({
        ref: ref
    }, props));
});
ImgForwardRef.displayName = "ImgForwardRef";
/* harmony default export */ var Image_Img = (ImgForwardRef);

;// CONCATENATED MODULE: ./src/components/Image/isRemote.js
function isRemote(src) {
    return src.indexOf("//") !== -1;
};

;// CONCATENATED MODULE: ./src/components/Image/localImageSource.js
function localImageSource(src) {
    return "/images/".concat(src);
};

;// CONCATENATED MODULE: ./src/components/Image/Source.js


var Source_defaultProps = {
    sizes: null,
    srcset: null,
    media: "all"
};
var Source_propTypes = {
    sizes: (prop_types_default()).string,
    srcset: (prop_types_default()).string,
    type: (prop_types_default()).string.isRequired,
    media: prop_types_default().oneOfType([
        prop_types_default().oneOf([
            "all",
            "print",
            "screen",
            "speech"
        ]),
        (prop_types_default()).string, 
    ])
};
function Source(param) {
    var sizes = param.sizes, srcset = param.srcset, type = param.type, media = param.media;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
        sizes: sizes,
        srcSet: srcset,
        type: type,
        media: media
    });
};
Source.defaultProps = Source_defaultProps;
Source.propTypes = Source_propTypes;

;// CONCATENATED MODULE: ./src/components/Image/renderSources.js


function renderSources(sources) {
    var keys = Object.keys(sources);
    if (keys === null || keys.length === 0) {
        return null;
    }
    return keys.map(function(type, index) {
        var src = sources[type];
        var srcSet = src;
        var sizes = null;
        if (Array.isArray(src) === true) {
            srcSet = src[0];
            sizes = src[1];
        }
        return renderSource(index, type, srcSet, sizes);
    });
};
function renderSource(index, type, srcSet) {
    var sizes = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Source, {
        type: type,
        srcSet: srcSet,
        sizes: sizes
    }, "source-".concat(index));
}

;// CONCATENATED MODULE: ./src/components/Image/Image.js










var Image_defaultProps = {
    fluid: false,
    sources: null,
    srcSet: null,
    sizes: null,
    className: ""
};
var Image_propTypes = {
    src: (prop_types_default()).string.isRequired,
    sources: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).object
    ]),
    srcSet: (prop_types_default()).string,
    sizes: (prop_types_default()).string,
    fluid: (prop_types_default()).bool,
    className: (prop_types_default()).string
};
function Image(_param) {
    var src = _param.src, sources = _param.sources, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "sources"
    ]);
    var hasSources = sources && sources.length !== 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Picture, {
        children: [
            hasSources && renderSources(sources),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Img, (0,_object_spread/* default */.Z)({
                src: isRemote(src) ? src : localImageSource(src)
            }, rest))
        ]
    });
}
Image.defaultProps = Image_defaultProps;
Image.propTypes = Image_propTypes;
var ImageForwardRef = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var alt = _param.alt, props = (0,_object_without_properties/* default */.Z)(_param, [
        "alt"
    ]);
    return (0,jsx_runtime.jsx)(Image, (0,_object_spread/* default */.Z)({
        ref: ref,
        alt: alt
    }, props));
});
ImageForwardRef.displayName = "ImageForwardRef";
/* harmony default export */ var Image_Image = (ImageForwardRef);

;// CONCATENATED MODULE: ./src/components/Image/index.js

/* harmony default export */ var components_Image = (Image_Image);


/***/ }),

/***/ 19296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Paragraph; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/components/Paragraph/Paragraph.js





var defaultProps = {
    className: "",
    children: null
};
var propTypes = {
    className: (prop_types_default()).string,
    children: (prop_types_default()).node
};
function Paragraph(_param) {
    var className = _param.className, children = _param.children, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className
    }, otherProps), {
        children: children
    }));
};
Paragraph.defaultProps = defaultProps;
Paragraph.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/components/Paragraph/index.js

/* harmony default export */ var components_Paragraph = (Paragraph);


/***/ }),

/***/ 37346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Text; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(19296);
;// CONCATENATED MODULE: ./src/components/Text/Text.js




var defaultProps = {
    muted: false,
    xsmall: false,
    small: false,
    large: false,
    medium: false,
    semibold: false,
    className: "",
    children: ""
};
var propTypes = {
    muted: (prop_types_default()).bool,
    xsmall: (prop_types_default()).bool,
    small: (prop_types_default()).bool,
    large: (prop_types_default()).bool,
    medium: (prop_types_default()).bool,
    semibold: (prop_types_default()).bool,
    className: (prop_types_default()).string,
    children: (prop_types_default()).node
};
function Text(param) {
    var muted = param.muted, xsmall = param.xsmall, small = param.small, large = param.large, medium = param.medium, semibold = param.semibold, className = param.className, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
        className: (0,clsx_m/* default */.Z)(className, {
            "text-gray-500": muted,
            "text-xs": xsmall,
            "text-sm": small,
            "text-lg": large,
            "font-medium": medium,
            "font-semibold": semibold
        }),
        children: children
    });
};
Text.defaultProps = defaultProps;
Text.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/components/Text/index.js

/* harmony default export */ var components_Text = (Text);


/***/ }),

/***/ 46918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ view_Copyright; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/view/Copyright/Copyright.js

function Copyright() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: "text-sm text-gray-500",
        children: "\xa9 2020 Asociaci\xf3n Iberoamericana de Scrum"
    });
};

;// CONCATENATED MODULE: ./src/view/Copyright/index.js

/* harmony default export */ var view_Copyright = (Copyright);


/***/ }),

/***/ 16625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FooterMenu; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./content/menu.json
var menu_namespaceObject = JSON.parse('{"S9":{"TN":"Empresa","ev":[{"title":"Quiénes somos","url":"/nosotros/"},{"title":"Consultoría empresarial","url":"/consultoria-y-entrenamiento/"},{"title":"Contáctenos","url":"/contacto/"},{"title":"Red de socios","url":"/socios/"},{"title":"Portal de socios","url":"https://socios.aibes.org/","isNew":true}]},"_9":{"TN":"Entrenamientos","ev":[{"title":"Información de cursos","url":"/entrenamientos/"},{"title":"Entrenadores","url":"/entrenadores/"},{"title":"Formación de entrenadores","url":"/formacion-de-entrenadores-scrum/"},{"title":"Exámenes de práctica","url":"/examenes-de-practica/"}]},"Jb":{"TN":"Recursos","ev":[{"title":"La guía de Scrum","url":"https://www.scrumguides.org/","target":"_blank"},{"title":"Libros electrónicos","url":"/recursos/libros"},{"title":"Materiales de Scrum","url":"/recursos/materiales"},{"title":"Manual de uso de la marca","url":"https://marca.aibes.org/"},[{"title":"Términos","url":"/legal/tos"},{"title":"privacidad","url":"/legal/privacidad"}],{"title":"Política de cookies","url":"/legal/cookies/"}]},"bJ":{"TN":"Comunidad","ev":[{"title":"Involucrarse","url":"/comunidad/"},{"title":"Artículos del blog","url":"/blog/"},{"title":"Validación de certificaciones","url":"/validar-certificacion"},{"title":"Eventos","url":"/eventos/"}]}}');
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./src/components/ListItem/index.js + 1 modules
var ListItem = __webpack_require__(69505);
// EXTERNAL MODULE: ./src/components/UnorderedList/index.js + 1 modules
var UnorderedList = __webpack_require__(25747);
// EXTERNAL MODULE: ./src/helpers/uniqueKey.js
var uniqueKey = __webpack_require__(32223);
// EXTERNAL MODULE: ./src/components/Link/index.js + 2 modules
var Link = __webpack_require__(48300);
;// CONCATENATED MODULE: ./src/view/Footer/NewBadge.js

function NewBadge() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "ml-2 inline-flex rounded-full bg-yellow-100 px-2 py-1 text-xs font-medium leading-none text-yellow-900",
        children: "Nuevo"
    });
};

;// CONCATENATED MODULE: ./src/view/Footer/MenuItem.js




var defaultProps = {
    isNew: false
};
var propTypes = {
    url: (prop_types_default()).string.isRequired,
    title: (prop_types_default()).string.isRequired,
    isNew: (prop_types_default()).bool
};
function MenuItem(param) {
    var url = param.url, title = param.title, isNew = param.isNew;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
        className: "-mx-2 my-px inline-flex items-center py-1 px-2 font-medium leading-normal text-gray-900 transition duration-300 ease-in-out hover:text-gray-600 lg:text-sm",
        href: url,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "block flex-1",
                children: title
            }),
            isNew && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewBadge, {})
        ]
    });
};
MenuItem.defaultProps = defaultProps;
MenuItem.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/view/Footer/MenuItems.js







var MenuItems_defaultProps = {
    items: []
};
var menuItemShape = prop_types_default().shape({
    title: (prop_types_default()).string,
    url: (prop_types_default()).string
});
var MenuItems_propTypes = {
    items: prop_types_default().arrayOf(prop_types_default().oneOfType([
        menuItemShape,
        prop_types_default().arrayOf(menuItemShape)
    ]))
};
function MenuItems(param) {
    var items = param.items;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UnorderedList/* default */.Z, {
        children: items.map(function(item) {
            if ((0,lodash.isArray)(item)) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                    children: item.map(function(param, index) {
                        var title = param.title, url = param.url, isNew = param.isNew;
                        var multipleItems = [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                                url: url,
                                title: title,
                                isNew: isNew
                            }, (0,uniqueKey/* default */.Z)(url)), 
                        ];
                        if (index < item.length - 1) {
                            multipleItems.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "\xa0y\xa0"
                            }, (0,uniqueKey/* default */.Z)("menu-multiple-divider")));
                        }
                        return multipleItems;
                    })
                }, (0,uniqueKey/* default */.Z)("menu"));
            }
            if ((0,lodash.isObject)(item)) {
                var title = item.title, url = item.url, isNew = item.isNew;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                        url: url,
                        title: title,
                        isNew: isNew
                    })
                }, (0,uniqueKey/* default */.Z)(url));
            }
            return null;
        })
    });
};
MenuItems.defaultProps = MenuItems_defaultProps;
MenuItems.propTypes = MenuItems_propTypes;

;// CONCATENATED MODULE: ./src/view/Footer/Menu.js



var Menu_defaultProps = {
    items: []
};
var Menu_menuItemShape = prop_types_default().shape({
    title: (prop_types_default()).string,
    url: (prop_types_default()).string
});
var Menu_propTypes = {
    title: (prop_types_default()).string.isRequired,
    items: prop_types_default().arrayOf(prop_types_default().oneOfType([
        Menu_menuItemShape,
        prop_types_default().arrayOf(Menu_menuItemShape)
    ]))
};
function Menu(param) {
    var title = param.title, items = param.items;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "mt-0 mb-0 text-base font-semibold",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pt-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItems, {
                    items: items
                })
            })
        ]
    });
};
Menu.defaultProps = Menu_defaultProps;
Menu.propTypes = Menu_propTypes;

;// CONCATENATED MODULE: ./src/view/Footer/FooterMenuCompany.js



function FooterMenuCompany() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu, {
        title: menu_namespaceObject.S9.TN,
        items: menu_namespaceObject.S9.ev
    });
};

;// CONCATENATED MODULE: ./src/view/Footer/FooterMenuTrainings.js



function FooterMenuTrainings() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu, {
        title: menu_namespaceObject._9.TN,
        items: menu_namespaceObject._9.ev
    });
};

;// CONCATENATED MODULE: ./src/view/Footer/FooterMenuResources.js



function FooterMenuResources() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu, {
        title: menu_namespaceObject.Jb.TN,
        items: menu_namespaceObject.Jb.ev
    });
};

;// CONCATENATED MODULE: ./src/view/Footer/FooterMenuCommunity.js



function FooterMenuCommunity() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu, {
        title: menu_namespaceObject.bJ.TN,
        items: menu_namespaceObject.bJ.ev
    });
};

;// CONCATENATED MODULE: ./src/view/Footer/FooterMenu.js





function FooterMenu() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-1 gap-6 sm:grid-cols-12",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-1 gap-6 sm:col-span-6 md:grid-cols-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterMenuCompany, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterMenuTrainings, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-1 gap-6 sm:col-span-6 md:grid-cols-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterMenuResources, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterMenuCommunity, {})
                ]
            })
        ]
    });
};


/***/ }),

/***/ 179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ view_Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/Container/index.js
var Container = __webpack_require__(30341);
// EXTERNAL MODULE: ./src/view/Brand/index.js + 4 modules
var Brand = __webpack_require__(45881);
// EXTERNAL MODULE: ./src/components/Image/index.js + 7 modules
var Image = __webpack_require__(31233);
;// CONCATENATED MODULE: ./src/view/About/About.js



function About() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-row items-center space-x-4 lg:flex-col lg:items-start lg:space-x-0 lg:space-y-4 lg:pr-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Brand/* default */.Z, {
                    hideName: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: "flex-1 text-base font-medium leading-5 tracking-tight md:text-lg md:leading-relaxed lg:flex-auto",
                children: "Somos la certificadora preferida por hispanohablantes"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "inline-flex font-medium leading-5 text-gray-500 lg:text-sm lg:font-normal",
                children: [
                    "Insignias v\xeda\xa0\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        title: "Asociaci\xf3n Iberoamericana de Scrum AIBES en Credly",
                        href: "https://www.credly.com/organizations/asociacion-iberoamericana-de-scrum",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            alt: "Credly",
                            src: "credly.webp",
                            width: 50
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/view/About/index.js

/* harmony default export */ var view_About = (About);

// EXTERNAL MODULE: ./src/view/Social/index.js + 10 modules
var Social = __webpack_require__(3577);
// EXTERNAL MODULE: ./src/components/Text/index.js + 1 modules
var Text = __webpack_require__(37346);
// EXTERNAL MODULE: ./src/components/Link/index.js + 2 modules
var Link = __webpack_require__(48300);
;// CONCATENATED MODULE: ./src/view/SecurePayments/PayPal.js



function PayPal() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            title: "Pagos Seguros en L\xednea con PayPal",
            href: "https://www.paypal.com/co/webapps/mpp/paypal-safety-and-security",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "payments/paypal.svg",
                className: "h-auto max-w-full",
                alt: "PayPal",
                width: 124,
                height: 33
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/view/SecurePayments/Paymentez.js



function Paymentez() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-28",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            title: "Pagos Seguros en L\xednea con Paymentez",
            href: "https://seal.controlcase.com/index.php?page=showCert&cId=2595630504",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "payments/paymentez.png",
                className: "h-auto max-w-full",
                alt: "Paymentez",
                width: 800,
                height: 144
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/view/SecurePayments/SecurePayments.js




function SecurePayments() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col space-y-2 md:flex-row md:items-center md:space-y-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                className: "mr-3 whitespace-nowrap",
                small: true,
                medium: true,
                muted: true,
                children: "Pagos seguros con"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center space-x-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paymentez, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PayPal, {})
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/view/SecurePayments/index.js

/* harmony default export */ var view_SecurePayments = (SecurePayments);

// EXTERNAL MODULE: ./src/view/Copyright/index.js + 1 modules
var Copyright = __webpack_require__(46918);
// EXTERNAL MODULE: ./src/view/Footer/FooterMenu.js + 9 modules
var FooterMenu = __webpack_require__(16625);
;// CONCATENATED MODULE: ./src/view/Footer/Footer.js







function Footer() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: "relative bg-white text-gray-800 lg:pt-10",
        role: "contentinfo",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative z-10 flex w-full flex-col",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.ZP, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid grid-cols-1 space-y-10 py-10 md:grid-cols-12 md:space-y-0 lg:grid-cols-12 lg:space-y-0 lg:space-x-10 xl:pb-16",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-span-1 space-y-6 md:col-span-12 lg:col-span-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(view_About, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Social/* default */.Z, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-span-1 md:col-span-12 lg:col-span-9",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterMenu/* default */.Z, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "border-t border-gray-200",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col space-y-4 py-6 text-gray-600 md:flex-row md:items-center md:space-x-6 md:space-y-0 lg:space-x-0 lg:py-10",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex items-center md:flex-1 lg:space-x-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Copyright/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(view_SecurePayments, {})
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pointer-events-none absolute inset-0 z-0 opacity-50 dark:bg-black"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/view/Footer/index.js

/* harmony default export */ var view_Footer = (Footer);


/***/ }),

/***/ 3577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ view_Social; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Tooltip/index.js + 1 modules
var Tooltip = __webpack_require__(95888);
;// CONCATENATED MODULE: ./src/view/Social/SocialLink.js



var propTypes = {
    href: (prop_types_default()).string.isRequired,
    title: (prop_types_default()).string.isRequired,
    children: (prop_types_default()).node.isRequired
};
function SocialLink(param) {
    var href = param.href, title = param.title, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
        tooltip: title,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "block w-8 text-gray-400 hover:text-green-600",
            href: href,
            children: children
        })
    });
};
SocialLink.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/view/Social/LinkedIn/LinkedIn.js


function LinkedIn() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLink, {
        title: "LinkedIn",
        href: "https://www.linkedin.com/company/aibes/",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            className: "h-auto max-w-full fill-current",
            role: "img",
            viewBox: "0 0 48 48",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "LinkedIn"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM11.5216 19.8778H16.9605V36.2196H11.5216V19.8778ZM17.3188 14.8227C17.2835 13.2204 16.1377 12 14.277 12C12.4164 12 11.2 13.2204 11.2 14.8227C11.2 16.3918 12.3805 17.6473 14.2064 17.6473H14.2412C16.1377 17.6473 17.3188 16.3918 17.3188 14.8227ZM30.3131 19.4941C33.8922 19.4941 36.5754 21.8303 36.5754 26.8497L36.5752 36.2196H31.1365V27.4767C31.1365 25.2807 30.3494 23.7822 28.3805 23.7822C26.8779 23.7822 25.9829 24.7924 25.5898 25.7682C25.446 26.1178 25.4107 26.605 25.4107 27.0934V36.22H19.9711C19.9711 36.22 20.0428 21.4117 19.9711 19.8783H25.4107V22.1929C26.1325 21.0802 27.4254 19.4941 30.3131 19.4941Z",
                    fill: "current"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/view/Social/LinkedIn/index.js

/* harmony default export */ var Social_LinkedIn = (LinkedIn);

;// CONCATENATED MODULE: ./src/view/Social/Facebook/Facebook.js


function Facebook() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLink, {
        title: "Facebook",
        href: "https://www.facebook.com/AIBE.Scrum",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            className: "h-auto max-w-full fill-current",
            role: "img",
            viewBox: "0 0 48 48",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Facebook"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM26.5016 25.0542V38.1115H21.0991V25.0547H18.4V20.5551H21.0991V17.8536C21.0991 14.1828 22.6231 12 26.9532 12H30.5581V16.5001H28.3048C26.6192 16.5001 26.5077 17.1289 26.5077 18.3025L26.5016 20.5546H30.5836L30.1059 25.0542H26.5016Z",
                    fill: "current"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/view/Social/Facebook/index.js

/* harmony default export */ var Social_Facebook = (Facebook);

;// CONCATENATED MODULE: ./src/view/Social/Instagram/Instagram.js


function Instagram() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLink, {
        title: "Instagram",
        href: "https://www.instagram.com/aibesorg/",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            className: "max-w-full fill-current",
            role: "img",
            viewBox: "0 0 3333 3333",
            xmlns: "http://www.w3.org/2000/svg",
            shapeRendering: "geometricPrecision",
            textRendering: "geometricPrecision",
            imageRendering: "optimizeQuality",
            fillRule: "evenodd",
            clipRule: "evenodd",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Instagram"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M1667 0c920 0 1667 746 1667 1667 0 920-746 1667-1667 1667C747 3334 0 2588 0 1667 0 747 746 0 1667 0zm-390 752h780c293 0 532 237 532 525v778c0 289-239 525-532 525h-780c-293 0-532-236-532-525v-778c0-289 240-525 532-525zm385 421c285 0 516 231 516 516s-231 516-516 516-516-231-516-516 231-516 516-516zm0 174c188 0 341 153 341 341s-153 341-341 341c-189 0-341-153-341-341s153-341 341-341zm499-246c46 0 84 37 84 84 0 46-37 84-84 84-46 0-84-37-84-84 0-46 37-84 84-84zm-820-200h652c245 0 445 199 445 443v656c0 244-200 443-445 443h-652c-245 0-445-199-445-443v-656c0-244 200-443 445-443z"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/view/Social/Instagram/index.js

/* harmony default export */ var Social_Instagram = (Instagram);

;// CONCATENATED MODULE: ./src/view/Social/YouTube/YouTube.js


function YouTube() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLink, {
        title: "Youtube",
        href: "https://www.youtube.com/channel/UCmb9zIvYu4sZmuHUX0aLFEQ",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            className: "h-auto max-w-full fill-current",
            role: "img",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 48 48",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "YouTube"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM34.0016 15.7493C35.1031 16.0516 35.9706 16.9422 36.265 18.0732C36.8 20.123 36.8 24.4 36.8 24.4C36.8 24.4 36.8 28.6768 36.265 30.7268C35.9706 31.8578 35.1031 32.7484 34.0016 33.0508C32.0054 33.6 24 33.6 24 33.6C24 33.6 15.9946 33.6 13.9983 33.0508C12.8967 32.7484 12.0292 31.8578 11.7348 30.7268C11.2 28.6768 11.2 24.4 11.2 24.4C11.2 24.4 11.2 20.123 11.7348 18.0732C12.0292 16.9422 12.8967 16.0516 13.9983 15.7493C15.9946 15.2 24 15.2 24 15.2C24 15.2 32.0054 15.2 34.0016 15.7493Z",
                    fill: "current"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M21.6 28.8V20.8L28 24.8001L21.6 28.8Z",
                    fill: "current"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/view/Social/YouTube/index.js

/* harmony default export */ var Social_YouTube = (YouTube);

;// CONCATENATED MODULE: ./src/view/Social/Social.js





function Social() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center space-x-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Social_LinkedIn, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Social_Facebook, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Social_Instagram, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Social_YouTube, {})
        ]
    });
};

;// CONCATENATED MODULE: ./src/view/Social/index.js

/* harmony default export */ var view_Social = (Social);


/***/ })

}]);